import { requirePermission } from '@/utils/auth'
import { createFileRoute, redirect } from '@tanstack/react-router'
import dayjs from 'dayjs'

export const Route = createFileRoute('/driver-statistics')({
  beforeLoad: ({ location }) => {
    requirePermission('drive_statistics')

    if (location.pathname === '/driver-statistics' || location.pathname === '/driver-statistics/') {
      const now = dayjs()
      const endDate = now.format('YYYY-MM-DD')
      const startDate = now.subtract(7, 'day').format('YYYY-MM-DD')

      throw redirect({
        to: '/driver-statistics/$startDate/$endDate',
        params: {
          startDate,
          endDate,
        },
      })
    }
  },
})
